import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useDispatch, useSelector } from 'react-redux';
import {useRouter} from '../../../../../@casino/useRouter';
import { setGetSupportView } from '../../store/thunk/setGetSupportView';
import SupportItem from '../../components/supportItem';
import { setPostSupportUpdateStatus } from '../../store/thunk/setPostSupportUpdateStatus';

const ViewSupport = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.query;
    
    React.useEffect(() => {
        dispatch(setPostSupportUpdateStatus({
            id
        }))
        dispatch(setGetSupportView({
            id
        }))
    }, [id])

    const view = useSelector(state => state.supportMobile.view);

    return (
        <TemplatePage   
            title="Техническая поддержка"
            backUrl="/support/list"
        >   
            {
                Object.keys(view).length && <SupportItem item={view} view/>
            }
        </TemplatePage>
    )
}

export default ViewSupport;